<div [class.container]="isGalleryRootPage">
  <div class="gallery">
    @for (galleryItem of galleryItems; track $index) {
      <app-gallery-item [galleryItem]="galleryItem" />
    }
  </div>
</div>
